var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_766_894)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5859 16.0355L10.1717 14.6213L12.6466 12.1464C13.2323 11.5606 13.2323 10.6109 12.6466 10.0251C12.0608 9.43933 11.111 9.43933 10.5252 10.0251L6.9897 13.5606C5.62287 14.9275 5.62287 17.1436 6.9897 18.5104C8.35654 19.8772 10.5726 19.8772 11.9395 18.5104L19.0105 11.4393C20.3774 10.0725 20.3774 7.85642 19.0105 6.48958L18.657 6.13603C17.4854 4.96445 15.5859 4.96445 14.4143 6.13603L13.0001 4.72181C14.9527 2.76919 18.1186 2.76919 20.0712 4.72181L20.4247 5.07537C22.5726 7.22325 22.5726 10.7057 20.4247 12.8535L13.3537 19.9246C11.2058 22.0725 7.72337 22.0725 5.57549 19.9246C3.42761 17.7767 3.42761 14.2943 5.57549 12.1464L9.11102 8.6109C10.4779 7.24407 12.6939 7.24407 14.0608 8.6109C15.4276 9.97774 15.4276 12.1938 14.0608 13.5606L11.5859 16.0355Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_766_894"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClip);
export default __webpack_public_path__ + "static/media/clip.52c800b2a03b75eb7b5a101493200efe.svg";
export { ForwardRef as ReactComponent };